var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallcobLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8046 42.3897L7.81094 16.3826H0.333496L17.1258 49.933H17.1307L20.8046 42.3897Z",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6024 17.0198L36.8831 24.6556L41.168 33.4532L44.8888 25.8127L40.6068 17.0198H40.6024Z",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1601 17.0198C32.1419 19.1099 26.763 30.1562 17.1309 49.933C25.7896 49.933 15.9036 49.933 24.5737 49.933C42.8328 12.4402 31.9499 34.784 40.6025 17.0198C31.9313 17.0198 41.8423 17.0198 33.1601 17.0198Z",
    fill: "#D80032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8917 10.1396C43.268 29.1545 46.7472 22.1381 36.8213 42.5181L40.5913 50.0601C50.5945 29.5132 46.6697 37.4743 60.3336 10.1397H52.8918L52.8917 10.1396Z",
    fill: "#D80032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34772 10L0.333496 16.3825C5.68414 16.3825 11.0158 16.3825 16.3526 16.3825L20.6394 10C15.1176 10 21.8457 10 5.34769 10H5.34772Z",
    fill: "#D80032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4813 33.6953L28.8005 41.2537C28.8021 41.2574 33.1428 49.9292 33.1443 49.9329H40.5839L40.5913 49.9204C37.093 42.921 36.9098 42.5558 32.4813 33.6953V33.6953Z",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6396 10L16.3528 16.3825L25.0291 33.7173L28.712 26.1532C26.7846 22.2966 22.2023 13.1273 20.6396 10L20.6396 10Z",
    fill: "#1E293B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.666748)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallcobLogo);
export default __webpack_public_path__ + "static/media/wallcob-logo.88c597059fe2263b5e8930bbe045ad32.svg";
export { ForwardRef as ReactComponent };